export default __webpack_public_path__ + "static/infra_4-e7a4eb30fb2576ea07273f807097c301.jpeg";